import { PostCard } from '@/components/blog/PostCard'
import { useBlog } from '@/hooks/useBlog'
import { BookOpen } from 'lucide-react'

export function BlogScreen() {
  const { posts, loading, loadMore, hasMore } = useBlog()

  const adaptedPosts = posts.map(post => ({
    id: post.id,
    slug: post.slug,
    title: post.title,
    excerpt: post.summary || '',
    content: post.content || '',
    author: { name: 'RegenerAI', avatar: '' },
    category: post.taxonomies?.[0]?.name || 'Geral',
    tags: post.taxonomies?.map(t => t.slug) || [],
    image: post.cover_image_url || '',
    publishedAt: post.published_at || post.created_at,
    readTime: 5,
    likes: post.like_count,
    comments: post.comment_count,
    views: post.view_count
  }))

  return (
    <div className="flex flex-col h-full">
      <div className="flex-shrink-0 bg-brand-surface border-b border-brand-border">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center gap-3 mb-2">
            <BookOpen size={24} className="text-brand-primary" />
            <h1 className="text-2xl font-bold text-brand-text">Blog RegenerAI</h1>
          </div>
          <p className="text-brand-text-secondary text-sm">
            Descubra conteúdo sobre agricultura regenerativa e práticas sustentáveis
          </p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto bg-brand-bg scrollbar-thin pb-20 lg:pb-0">
        <div className="max-w-6xl mx-auto px-4 py-6">
          {loading && posts.length === 0 && (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-10 w-10 border-2 border-brand-primary border-t-transparent mx-auto"></div>
              <p className="mt-4 text-brand-text-muted text-sm">Carregando posts...</p>
            </div>
          )}

          {!loading || posts.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {adaptedPosts.map((post) => (
                <PostCard key={post.id} post={post} />
              ))}
            </div>
          ) : null}

          {!loading && posts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-brand-text-muted">Nenhum post encontrado.</p>
            </div>
          )}

          {hasMore && (
            <div className="text-center mt-8">
              <button
                onClick={loadMore}
                disabled={loading}
                className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 mx-auto"
              >
                {loading ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Carregando...
                  </>
                ) : (
                  'Carregar Mais'
                )}
              </button>
            </div>
          )}

          {!hasMore && posts.length > 0 && (
            <div className="text-center py-8">
              <p className="text-brand-text-muted text-sm">
                Você já viu todos os nossos posts!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
